__turbopack_context__.v({
  "accountAll": "MobileBlockHeader-module-scss-module__jmFndW__accountAll",
  "blockHeader": "MobileBlockHeader-module-scss-module__jmFndW__blockHeader",
  "blockTitle": "MobileBlockHeader-module-scss-module__jmFndW__blockTitle",
  "withMargin": "MobileBlockHeader-module-scss-module__jmFndW__withMargin",
});
